<template>
<header id="header">
    <div class="headWrapper clearfix">
        <router-link to="/" tag="a" class="logo">
            <span class="declaration">把电商客户，变成你的终身客户</span>
        </router-link>
        <ul class="navList clearfix">
            <li class="navItem" :class="currentNavItem==1?'on':''" @click="currentNavItem=1">
                <router-link to="/" tag="a">
                    首页
                </router-link>
            </li>
            <li class="navItem" :class="currentNavItem==2?'on':''" @click="currentNavItem=2">
                <router-link to="/product" tag="a">产品和服务</router-link>
            </li>
            <li class="navItem" :class="currentNavItem==3?'on':''" @click="currentNavItem=3">
                <a  href="#customerCase" @click="setAnchor('customerCase')">客户案例</a>
            </li>
            <!-- <li class="navItem" :class="currentNavItem==4?'on':''" @click="currentNavItem=4">
                <a>逐鹿学堂</a>
                <ul class="dropdown-menu">
                    <li>
                        <router-link to="/dynamic" tag="a">干货分享</router-link>
                    </li>
                    <li>
                        <router-link to="/course" tag="a">使用大全</router-link>

                    </li>
                </ul>
            </li> -->
            <li class="navItem" :class="currentNavItem==5?'on':''" @click="currentNavItem=5">
                <a href="#contactUs">联系我们</a>
            </li>
            <li class="navItem" :class="currentNavItem==6?'on':''" @click="currentNavItem=6">
                <router-link class="register" to="/register" tag="a">注册账号</router-link>
            </li>
        </ul>

    </div>

</header>
</template>

<script>
export default {
    name: "HeaderComponent",
    data() {
        return {
            currentNavItem: "1",
        }
    },
    methods: {
        setAnchor(selector) {
            sessionStorage.setItem("zhongshenkeanchor", selector)
            this.$router.push("/");
        }
    }
}
</script>

<style lang="scss" scoped>
$color:#434343;
$activeColor: #02b907;

#header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999999;
    background: #fff;
    box-shadow: 0 0 15px #dbdbdb;
    height: 90px;
    padding: 20px 20px;
}

.headWrapper {
    width: 1250px;
    margin: 0 auto;

    .logo {
        float: left;
        width: 400px;
        padding-left: 158px;
        height: 50px;
        background: url('../../assets/Images/index-logo.png') 0 0 no-repeat;

        .declaration {
            display: inline-block;
            margin-top: 15px;
            line-height: 22px;
            border-left: 2px solid #dbdbdb;
            padding-left: 12px;
            color: #959595;
            font-size: 13px;
        }
    }

    .navList {
        float: right;

        .navItem {
            float: left;
            list-style: none;
            font-size: 16px;
            padding: 5px 13px;
            position: relative;

            &>a {
                padding: 5px 2px;
                color: #434343;
                display: inline-block;
                text-decoration: none;
                border-bottom: 2px solid transparent;
                transition: all .3s linear;

                &.register {
                    padding: 5px 15px;
                    border-radius: 15px;
                    color: #fff !important;
                    margin-top: 1px;
                    background: linear-gradient(to right, #00aef0, #00e37e);
                    border-bottom: none;
                    background-color: #00e37e \9\0;
                }
            }

            &.on>a,
            &:hover>a {
                color: $activeColor;
            }

            &:hover>a.register {
                background: linear-gradient(to right, #00a5e4, #00ce72);
                border: 0;
                color: #fff;
            }

            &:hover .dropdown-menu {
                display: block;
            }

            .dropdown-menu {
                width: max-content;
                min-width: 100%;
                background: #fff;
                position: absolute;
                left: 50%;
                z-index: 100;
                transform: translateX(-50%);
                border: 1px solid #e7e5e5;
                line-height: 30px;
                text-align: center;
                font-size: 15px;
                color: #555;
                display: none;
                top: 40px;

                &:before,
                &:after {
                    content: '';
                    display: block;
                    width: 10px;
                    height: 10px;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%) rotate(45deg);
                }

                &:before {
                    background: #e7e5e5;
                    top: -5px;
                }

                &:after {
                    background: #fff;
                    top: -4px;
                }

                li {
                    cursor: pointer;
                    padding: 0 15px;
                    position: relative;
                    z-index: 10;

                    &:hover {
                        background: #f1fcf1;

                        a {
                            color: $activeColor
                        }
                    }
                }
            }
        }

    }
}
</style>
